// extracted by mini-css-extract-plugin
export default {"ul":"Feedback_ul__7r7b2","btn-btn":"Feedback_btn-btn__R1bev","btn":"Feedback_btn__KHny8"};